export default {
  white: '#fff',
  black: '#000',
  red: '#cb2027',
};
